import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "max-w-6xl mx-auto px-6 py-8" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center py-20"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-center justify-center text-center py-20 bg-white rounded-lg border border-gray-200"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "bg-white rounded-lg border border-gray-200 overflow-hidden"
}
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "border-b border-gray-200" }
const _hoisted_8 = { class: "text-left px-6 py-4 text-sm font-semibold text-gray-900 whitespace-nowrap" }
const _hoisted_9 = { class: "inline-flex items-center gap-1.5" }
const _hoisted_10 = { class: "relative inline-flex items-center group cursor-help shrink-0" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "absolute right-0 top-full mt-1 px-2 py-1.5 text-xs text-white bg-gray-900 rounded-md opacity-0 group-hover:opacity-100 transition-opacity shadow-lg z-50 pointer-events-none w-48 text-left flex flex-col gap-0.5" }
const _hoisted_13 = { class: "divide-y divide-gray-100" }
const _hoisted_14 = { class: "px-6 py-4 text-left" }
const _hoisted_15 = { class: "font-medium text-gray-900" }
const _hoisted_16 = { class: "px-6 py-4 text-left" }
const _hoisted_17 = { class: "text-sm text-gray-500" }
const _hoisted_18 = { class: "px-6 py-4 text-left" }
const _hoisted_19 = { class: "text-sm text-gray-700" }
const _hoisted_20 = {
  key: 0,
  class: "relative inline-block ml-1 group"
}
const _hoisted_21 = { class: "text-sm text-violet-500 cursor-default" }
const _hoisted_22 = { class: "absolute left-0 top-full mt-1 px-2 py-1.5 text-xs text-white bg-gray-900 rounded-md opacity-0 group-hover:opacity-100 transition-opacity shadow-lg z-50 pointer-events-none min-w-max" }
const _hoisted_23 = { class: "flex flex-col gap-0.5" }
const _hoisted_24 = { class: "px-6 py-4 text-left align-middle" }
const _hoisted_25 = { class: "w-24 h-10 flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrendSparkline = _resolveComponent("TrendSparkline")!
  const _component_TrendDetailModal = _resolveComponent("TrendDetailModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("div", { class: "w-12 h-12 border-4 border-violet-200 border-t-violet-600 rounded-full animate-spin mx-auto mb-4" }),
            _createElementVNode("p", { class: "text-gray-500" }, "Loading trends...")
          ], -1)
        ]))]))
      : (_ctx.trendingTopics.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "text-gray-400 mb-4 flex justify-center",
              innerHTML: _ctx.TRENDS_EMPTY_ICON
            }, null, 8, _hoisted_4),
            _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-2" }, " No trending topics yet ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-gray-500 max-w-md mx-auto" }, " As more calls are processed, you'll see trending topics and themes emerge here. Start by searching for specific topics. ", -1)),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToSearch && _ctx.goToSearch(...args))),
              class: "mt-6 px-6 py-2.5 bg-violet-600 text-white rounded-lg hover:bg-violet-700 transition-colors"
            }, " Search Calls ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("th", { class: "text-left px-6 py-4 text-sm font-semibold text-gray-900 whitespace-nowrap" }, " Topics ", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("th", { class: "text-left px-6 py-4 text-sm font-semibold text-gray-900 whitespace-nowrap" }, " Last Mentioned ", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("th", { class: "text-left px-6 py-4 text-sm font-semibold text-gray-900 whitespace-nowrap" }, " Experts ", -1)),
                  _createElementVNode("th", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _cache[5] || (_cache[5] = _createTextVNode(" Topic Trend ", -1)),
                      _createElementVNode("span", _hoisted_10, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.INFO_ICON,
                          class: "inline-flex w-4 h-4 shrink-0 text-gray-400 [&_svg]:w-full [&_svg]:h-full"
                        }, null, 8, _hoisted_11),
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TOPIC_TREND_TOOLTIP_LINES, (line, i) => {
                            return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(line), 1))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tbody", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trendingTopics, (topic) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: topic.topic,
                    class: "hover:bg-gray-50 transition-colors"
                  }, [
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(topic.topic), 1)
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatLastMentioned(topic)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.formatExperts(topic.expert_names)), 1),
                      (topic.expert_names.length > 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, " +" + _toDisplayString(topic.expert_names.length - 2) + " more ", 1),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topic.expert_names.slice(2), (name) => {
                                  return (_openBlock(), _createElementBlock("span", { key: name }, _toDisplayString(name), 1))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_TrendSparkline, {
                          data: topic.trend_data,
                          onClick: ($event: any) => (_ctx.openTrendModal(topic))
                        }, null, 8, ["data", "onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])),
    _createVNode(_component_TrendDetailModal, {
      topic: _ctx.selectedTopic,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTopic = null))
    }, null, 8, ["topic"])
  ]))
}